import React from 'react';
import { useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';

import { getSelectedLanguage, getTranslations } from 'modules/translations/selectors';
import { DEFAULT_LANGUAGE, getLocaleUsage } from 'constants/LanguageConstants';

const IntlWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const locale = useSelector(getSelectedLanguage);
  const messages = useSelector(getTranslations);

  const isReady = Object.keys(messages).length > 0;

  const userLocaleVariant = React.useMemo(() => getLocaleUsage(locale), [locale]);
  const defaultLocaleVariant = React.useMemo(() => getLocaleUsage(DEFAULT_LANGUAGE), []);

  return isReady && (
    <IntlProvider messages={messages} locale={userLocaleVariant} defaultLocale={defaultLocaleVariant}>
      {children}
    </IntlProvider>
  );
};

export default IntlWrapper;
